<template></template>

<script setup>
import { about } from "~/components/molecules/about";

import { map } from "~/lib/utils";
import { getFullTimelineLength } from "~/components/molecules/about/config";
import { organismMilestoneCanvasMonitor } from "~/lib/gsap-about";
import { killAnimation } from "~/lib/gsap-core";

const { milestones, progress } = defineProps({
    milestones: {
        type: Object,
        required: true,
    },
    progress: {
        type: Number,
        required: true,
    },
});

const { configs } = useExperience();

const { renderer, camera, scene } = useTresContext();

// Take over tresJS render loop
const { render, pauseRender, resumeRender } = useLoop();
render(() => {
    if (!about.isInited) return;
    if (camera.value) {
        // Use the cached fullLength
        const initialZ = getFullTimelineLength();
        const targetZ = 0;
        camera.value.position.z = map(progress, 0, 1, initialZ, targetZ);
    }
    about.update(progress, configs);
    about.postProcessor.render();
});

let tl = null;
onMounted(() => {
    setTimeout(() => {
        about.init(renderer.value, scene.value, camera.value, milestones);
    }, 500);
    tl = organismMilestoneCanvasMonitor(pauseRender, resumeRender);
});

// let lastFrameTime = 0;
// let accumulator = 0;
// const { onLoop } = useRenderLoop();
// onLoop(() => {
// const now = performance.now();
// const deltaTime = now - lastFrameTime;
// const frameDuration = 1000 / config.maxFPS; // Ensure config.maxFPS is defined
// lastFrameTime = now;
// accumulator += deltaTime;
// // Only update if enough time has passed
// if (accumulator >= frameDuration) {
//     accumulator = accumulator % frameDuration; // Reset accumulator with leftover time
//     if (camera.value) {
//         // Use the cached fullLength
//         const initialZ = getFullTimelineLength();
//         const targetZ = 0;
//         camera.value.position.z = map(progress, 0, 1, initialZ, targetZ);
//     }
//     about.update(progress, configs);
// }
// });

onBeforeUnmount(() => {
    killAnimation(tl);
    about.destroy();
});
</script>
